export default "__VITE_ASSET__6pdLF5ir__"